<script>
	import ParkingMap from "./ParkingMap.svelte";
	export let name = "";
</script>

<ParkingMap paywall={false} />
